/* TODO: move to the workWithObject helper */
export default function updateObject (firstObject, secondObject) {
  const objectKeys = Object.keys(firstObject).concat(Object.keys(secondObject));
  const updatedObject = {};
  objectKeys.filter((item, index) => objectKeys.indexOf(item) === index).map(key => {
    updatedObject[key] = typeof secondObject[key] !== 'undefined' ? secondObject[key] : firstObject[key];
  });
  return updatedObject;
}
